<template>
  <div class="looking_site">
    <van-sticky>
      <van-nav-bar title="申请成为场地" left-arrow @click-left="goback()" />
    </van-sticky>
    <van-image width="100%" src="/static/images/partner.jpg" height="200" fit="cover" />

    <div class="site_form">
      <van-form label-width="100" :show-error="false" @submit="onSubmit" error-message-align="right">
        <van-cell-group>
          <van-field input-align="right" required v-model="placeInfo.contactName" label="您的姓名" placeholder="请输入"
            :rules="[{ required: true, message: '请输入您的姓名' }]" />

          <van-field input-align="right" required v-model="placeInfo.contactNumber" label="联系电话" placeholder="请输入"
            :rules="[
              { required: true, message: '请输入联系电话' },
              { pattern: /^1[3456789]\d{9}$/, message: '联系电话格式错误！' },
            ]" />

          <van-field input-align="right" v-model="placeInfo.name" label="场地名称" placeholder="请输入">
          </van-field>

          <van-field input-align="right" required v-model="fieldValue" readonly label="所在地区" placeholder="请选择所在地区"
            @click="showCascader = true" :rules="[{ required: true, message: '请选择所在地区' }]" />

          <div class="form_feature">
            <div class="fs14">场地类型</div>
            <div class="feature_list">
              <div @click="changePlaceTypeIndex(index)" :class="[index === placeTypeIndex ? 'active' : '']"
                v-for="(item, index) in placeType" :key="item.itemId">
                {{ item.itemText }}
              </div>
            </div>
          </div>

          <div class="fs15 font-weightbold m-l10">输入场地说明</div>

          <van-field v-model="placeInfo.remark" rows="2" autosize type="textarea" placeholder="请简单描述你的场地情况（选填）"
            show-word-limit label-width="100" />
        </van-cell-group>

        <van-radio-group v-model="newvalue">
          <van-radio name="0" @click="dyDeselect(0)">我已阅读并同意 <span style="color: #2295ff"
              @click="PlaceAgreement">【场地协议】</span>
          </van-radio>
        </van-radio-group>

        <div class="form_btn">
          <van-button block color="#2295FF" type="info" native-type="submit">立即提交</van-button>
        </div>
      </van-form>
    </div>

    <van-popup v-model="showCascader" round position="bottom">
      <van-cascader v-model="cascaderValue" title="请选择所在地区" :options="options" @close="showCascader = false"
        @finish="onFinish" :field-names="{
          text: 'name',
          value: 'area_code',
          children: 'children',
        }" />
    </van-popup>
  </div>
</template>

<script>
import { Button } from "vant";
import { NavBar } from "vant";
import { Form, Field, CellGroup } from "vant";
import { RadioGroup, Radio } from "vant";
import { Icon } from "vant";
import { ActionSheet, Cascader, Popup, Image, Notify } from "vant";
import cityData from "@/assets/js/city.js";
import storage from "@/utils/storage";
export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
    [Image.name]: Image,
  },
  data() {
    return {
      // 场地方信息
      placeInfo: {
        name: "",
        contactName: "",
        contactNumber: "",
        province: "广东省",
        city: "中山市",
        district: "",
        address: "广东省/中山市",
        type: 0,
        remark: "",
      },

      placeType: [], //场地类型
      placeTypeIndex: 0, //当前所选场地方索引值

      showType: false,
      registerOptions: [{ name: "可注册" }, { name: "不可注册" }],

      showCascader: false,
      fieldValue: "广东省/中山市",
      cascaderValue: "",
      options: [],

      newvalue: null, //当前值
      oldvalue: null,

    };
  },

  //初始化加载
  created() {
    this.options = cityData.data;
    //申请场地-入驻申请-查看
    this.siteSupplierApplyDetailAPI();
  },

  methods: {
    //申请场地-入驻申请-查看
    siteSupplierApplyDetailAPI() {
      var that = this;
      that.$api
        .siteSupplierApplyDetailAPI("")
        .then(function (res) {
          if (res.data.code === 200) {
            // 申请状态，1-待审核/2-已完成/3-已拒绝
            //如果是被拒绝的状态，会有数据返回，就要直接赋值到表单中。否则无需赋值
            if (res.data.data.applyStatus === 3) {
              that.placeInfo = res.data.data;
              that.fieldValue =
                res.data.data.province +
                "/" +
                res.data.data.city +
                "/" +
                res.data.data.district;
              that.placeTypeIndex = Number(res.data.data.type);
              Notify({
                type: "warning",
                message: "您申请的场地请求未通过，请重新提交申请资料！",
              });
            }
            
          }

          //申请场地-入驻申请-获取场地类型
            that.siteSupplierApplyAdd();
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //申请场地-入驻申请-获取场地类型
    siteSupplierApplyAdd() {
      var that = this;
      that.$api
        .siteSupplierApplyAddAPI("")
        .then(function (res) {
          if (res.data.code === 200) {
            that.placeType = res.data.data.typeList;
            that.placeInfo.type = Number(that.placeType[0].itemId);
            storage.setToken(storage.getUserInfo()); //设置请求头值
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    PlaceAgreement() {
      this.$router.push({ name: "PlaceAgreement" });
    },

    dyDeselect(index) {
      // 判断当前值和旧的值是否相等
      if (index === this.oldvalue) {
        this.newvalue = null;
        this.oldvalue = null;
      } else {
        this.oldvalue = index;
      }
    },

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      var info = selectedOptions.map((option) => option.name);
      this.fieldValue = selectedOptions.map((option) => option.name).join("/");
      this.placeInfo.province = info[0];
      this.placeInfo.city = info[1];
      this.placeInfo.district = info[2];
      this.showCascader = false;
    },

    // 选中类型
    onSelectType(item) {
      this.showType = false;
    },

    //点击选中场地类型
    changePlaceTypeIndex(index) {
      this.placeTypeIndex = index;
      this.placeInfo.type = Number(this.placeType[index].itemId);
    },

    //提交申请场地
    onSubmit() {
      var that = this;
      if (that.newvalue != null) {
        that.$api
          .siteSupplierApplySaveAPI(that.placeInfo)
          .then(function (res) {
            if (res.data.code === 200) {
              //跳转提交帮我找场地表单成功界面
              that.$router.push({ path: "/personal/materialProgress" });
            }
          })
          .catch(function (err) {
            console.log("error");
          });
      } else {
        Notify({ type: "warning", message: "请点击同意场地协议！" });
        return;
      }
    },

  },
};
</script>

<style lang="less" scoped>
.looking_site {
  display: flex;
  flex-direction: column;

  .site_form {
    padding: 0px 10px;
    height: auto;

    .van-cell {
      display: flex;
      align-items: flex-start;
    }

    .van-field {
      /deep/ textarea {
        height: 100px !important;
        background: #f4f3f8;
        padding: 5px;
      }
    }

    .form_feature {
      color: #646566;
      margin: 15px 10px;

      .fs28::after {
        position: absolute;
        left: 75px;
        color: #ee0a24;
        margin-top: 15px;
        font-size: 7px;
        content: "*";
      }

      .feature_list {
        display: flex;
        justify-content: space-between;

        div {
          margin-top: 10px;
          border: 1px solid #ebe9e9;
          color: #999;
          width: 27%;
          font-size: 14px;
          text-align: center;
          padding: 5px;
          border-radius: 5px;
        }

        .active {
          background: #2295ff;
          color: #fff;
          border: 1px solid #fff;
        }
      }
    }
  }

  .van-radio-group {
    margin: auto;
    margin-top: 40px;
    font-size: 14px;
    display: flex;
    justify-content: center;
  }

  .form_btn {
    margin: 40px 10px;

    .van-button {
      height: 44px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/personal/applicationForSite.vue